module.exports = __webpack_public_path__ + "img/er8.2be8e776.png";